(function(){
	SUGApp.controller('helpController',
		['$scope', 'SUGUtilities', '$modal', '$window', '$location', '$sce', 'helpService',
			function ($scope, SUGUtilities, $modal, $window, $location, $sce, helpService) {

		var init = function () {
			$scope.frm = { subject: "", message: "" };
			$scope.faqResult = [];
			$scope.searchtext = "";

			$scope.getEpochTime = function () {
				newDate = helpService.today();
				(newDate.getTime() - newDate.getMilliseconds()) / 1000;
				return newDate;
			}
		};

		var wordCount = function (str) {
			var count = typeof str != 'undefined' && str.length ? str.split(' ').length : 0;
			return count;
		}

		var generateSearchText = function () {
			$scope.searchtext = '';
			var messagesubject = $scope.frm.subject;
			var subjectLen = wordCount(messagesubject);		//messagesubject ? messagesubject.length : 0;
			var messagebody = $scope.frm.message;
			var bodyLen = wordCount(messagebody);		//messagesubject ? messagesubject.length : 0;

			$scope.searchtext = subjectLen && bodyLen && subjectLen + bodyLen > 1 ? messagesubject + ' ' + messagebody : 
				messagesubject && subjectLen > 1 ? messagesubject :
				messagebody && bodyLen > 1 ? messagebody : 
				$scope.searchtext;
		}

		/**
		 * Validates the contact form before submitting
		 */
		$scope.validateForm = function () {	
			// strip out special chars from the message		
			$scope.frm.message = $scope.frm.message.replaceAll(/\,|\:|\&|\~|\?|\*|\!|\^|\<|\>|\(|\)|\[|\]|\{|\}|\\|\||"|'/g,"");
			$scope.frm.message = $scope.frm.message.replaceAll(/\;|\#/g,"");
			$scope.frm.message = $scope.frm.message.replaceAll(/[\r\n]+/g," ");
		};

		// retrieves search results based on specified search text
		var getDefaultFAQSuggestions = function () {
			helpService.getDefaultFAQSuggestions({})
			.then(
				function (result) {
					result = SUGUtilities.lowerCaseKeys(result);
					if (result.data.success) {
						$scope.defaultFAQSuggestions = result.data.data;
					}
				},
				function (result) {
					SUGUtilities.showAlert('An error occurred retrieving the data.');
				}
			);
		};
		getDefaultFAQSuggestions();

		$scope.setDefaultFAQSuggestions = function () {
			if (!$scope.faqResult || !$scope.faqResult.length) {
				$scope.faqResult = $scope.defaultFAQSuggestions;
			}
		}
		// retrieves search results based on specified search text
		$scope.getFAQSuggestions = function(autorun){
			var eowRegEx = new RegExp("[ .,!?]");
			generateSearchText();
			// When the search text is empty, revert the suggestions to the default
			if (!$scope.searchtext.length) {
				$scope.faqResult = $scope.defaultFAQSuggestions;
			}
			var countOfWords = wordCount($scope.searchtext);
			var endOfString = $scope.searchtext[$scope.searchtext.length -1];
			var isEndOfWord = eowRegEx.test(endOfString) ? true : false;
			var runCall = countOfWords > 2 && isEndOfWord ? true : false;
			// logic to determine when to run call to retrieve suggestions
			if ($scope.searchtext && (runCall || autorun)) {
				helpService.getFAQSuggestions({"searchtext" : $scope.searchtext, "searchMax":6 })
				.then(
					function(result){
						result = SUGUtilities.lowerCaseKeys(result);
						if (result.data.success) {
							$scope.faqResult = result.data.data;		
						}
					},
					function(result){
						SUGUtilities.showAlert('An error occurred retrieving the data.');
					}
				);
			}
		};

		// used to open links since Angular seems to be blocking them.
		$scope.gotoLink = function(url) {
			$window.location.href = url;
		};


		/* Alert Window Controller */
		$scope.viewFAQSuggestion = function (id) {
			var modalData = $scope.faqResult[id];

			var previewModalWindow = $modal.open({
				templateUrl: '/view/templates/faqsuggestion.html?v=' + $scope.epochTime,
				controller: modalController,
				resolve: {
					modalData: function () { return modalData; },
					title: function () { return ''; },
					confirmation: function () { return ''; },
					cancel: function () { return 'No'; },
					ok: function () { return 'Yes'; }
				}
			});

			previewModalWindow.result
				.then(function (response) {
					//do nothing
				}, function (response) {
					//Don't do anything
					//Cancel
				});
		};

		/* Modal Controller */
		var modalController = ['$scope', '$modalInstance', 'ok', 'cancel', 'modalData', '$filter', '$window',
			function ($scope, $modalInstance, ok, cancel, modalData, $filter, $window) {
				$scope.modalData = modalData;
				//$scope.confirmationTitle = title;
				//$scope.confirmationMessage = confirmation;
				$scope.okBtn = typeof ok !== 'undefined' ? ok : 'Yes';
				$scope.cancelBtn = typeof cancel !== 'undefined' ? cancel : 'No';
				//$scope.previewMode = true;
				$scope.ok = function () {
					$modalInstance.close(true);
					$window.location.href = "/support";
				};
				$scope.cancel = function () {
					$modalInstance.dismiss(false);
				};
			}];


		// initialize the controller
		init();

	}]);
}());

